import { db } from "../../../service/API";
import store from "../../store/store";

const ft = require("../Tools/FileTools");

export class ProjectConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  projectBeingOpened(project) {
    // TODO: On projects non existing in db retrieve project size
    this.checkIfProjectExist(project.path).then((query) => {
      if (query === undefined) {
        this.createNewProject(project);
      } else {
        if (query.length > 0) {
          this.updateProjectHistory(query[0].id_proj);
        } else {
          this.createNewProject(project);
        }
      }
    });
  }

  projectBeingSaved(project) {
    const path = project.path.replace(store.state.config.dirs.root, "");
    this.checkIfProjectExist(path).then((query) => {
      if (query.length === undefined || !(query.length > 0)) {
        this.createNewProject(project);
      } else {
        if (!project.isTemplate) {
          // TODO: MAKE ONE CALL TO DB
          this.updateProjectDuration(query[0].id_proj, project.duration);
          this.updateProjectSize(query[0].id_proj, project.width, project.height);
          this.updateProjectHistory(query[0].id_proj);
          ft.updatethumb(query[0].id_proj, project.thumbnail, project.isTemplate);
        } else {
          ft.updatethumb(query[0].id_temp, project.thumbnail, project.isTemplate);
        }
      }
    });
  }

  getProject() {
    return new Promise((resolve, reject) => {
      db.get("/ProjectConnector/listProject/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get project failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("get project error " + err.message);
        });
    });
  }

  getProjectInSchedule(path) {
    return new Promise((resolve, reject) => {
      db.post("/ProjectConnector/getProjectInSchedule/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data.length > 0);
          } else {
            return reject("get project in schedule failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("get project in schedule error " + err.message);
        });
    });
  }

  deleteProject(pid) {
    return new Promise((resolve, reject) => {
      db.delete("/ProjectConnector/deleteProject/", {
        sid: this.socId,
        pid: pid,
      })
        .then((response) => {
          if (response.status == 204) {
            ft.deletethumb(pid);
            return resolve();
          } else {
            return reject("delete project failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete project error " + err.message);
        });
    });
  }

  deleteProjectWithPath(path) {
    return new Promise((resolve, reject) => {
      db.delete("/ProjectConnector/deleteProjectWithPath/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else if (response.status == 200) {
            ft.deletethumb(response.data.pid);
            return resolve();
          } else {
            return reject("delete project by path failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete project by path error " + err.message);
        });
    });
  }

  addFlagNotfound(path) {
    return new Promise((resolve, reject) => {
      db.post("/ProjectConnector/addFlagNotfound/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else if (response.status == 200) {
            //ft.deletethumb(response.data.pid);
            return resolve();
          } else {
            return reject("addFlagNotfound failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("addFlagNotfound error " + err.message);
        });
    });
  }

  createNewProject(project) {
    return new Promise((resolve, reject) => {
      project.path = project.path.replace(store.state.config.dirs.root, "");

      if (project.isTemplate) project.shared = 0;
      let action = project.isTemplate ? "/TemplateConnector/createNewTemplate/" : "/ProjectConnector/createNewProject/";

      db.post(action, {
        sid: this.socId,
        newProject: project,
      })
        .then((response) => {
          if (response.status == 200) {
            const pid = response.data.insertId;

            this.insertProjectHistory(pid)
              .then((response) => {
                ft.updatethumb(pid, project.thumbnail, project.isTemplate);
                return resolve(response.data);
              })
              .catch((err) => {
                return reject(err);
              });
          } else {
            return reject("create new project failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("create new project error " + err.message);
        });
    });
  }

  checkIfProjectExist(projectPath) {
    let isTemplate = projectPath.includes("template");
    let url = isTemplate ? "/TemplateConnector/checkIfTemplateExist/" : "/ProjectConnector/checkIfProjectExist/";

    return new Promise((resolve, reject) => {
      db.post(url, {
        sid: this.socId,
        path: projectPath,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("check project exist failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("check project exist failed with error : " + err.message);
        });
    });
  }

  insertProjectHistory(pid) {
    return new Promise((resolve, reject) => {
      db.post("/ProjectConnector/insertProjectHistory/", {
        uid: this.userId,
        pid: pid,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert project history failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("insert project history failed with error : " + err.message);
        });
    });
  }

  updateProjectDuration(pid, duration) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectDuration", {
        pid: pid,
        duration: duration,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project duration failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project duration failed with error : " + err.message);
        });
    });
  }

  updateProjectSize(pid, width, height) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectSize", {
        pid: pid,
        width: width,
        height: height,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project size failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project size failed with error : " + err.message);
        });
    });
  }

  updateProjectHistory(pid) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectHistory/", {
        uid: this.userId,
        pid: pid,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project history failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project history failed with error : " + err.message);
        });
    });
  }

  updateProjectPath(filepath, newpath) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectPath", {
        filepath: filepath,
        newpath: newpath,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project path failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project path failed with error : " + err.message);
        });
    });
  }

  addProjectThumbnail(filepath, newpath) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/addProjectThumbnail", {
        filepath: filepath,
        newpath: newpath,
      })
        .then((response) => {
          if (response.status == 200) {
            ft.copythumb(response.data.pid, response.data.newPid);
            return resolve(response.data);
          } else {
            return reject("update project thumbnail failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project thumbnail failed with error : " + err.message);
        });
    });
  }

  getDuration(path) {
    return new Promise((resolve, reject) => {
      db.post("/ProjectConnector/getDuration/", { sid: this.socId, path: path })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              return resolve(response.data[0].duration);
            } else {
              return reject("get duration not found :" + path);
            }
          } else {
            return reject("get duration failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get duration failed with error : " + err.message);
        });
    });
  }

  getInfoWithPath(path) {
    return new Promise((resolve, reject) => {
      db.post("/ProjectConnector/getInfoWithPath/", {
        sid: this.socId,
        path: path,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              return resolve(response.data[0].id_proj);
            } else {
              return reject("get info with path not found");
            }
          } else {
            return reject("get info with path failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("get info with path failed with error : " + err.message);
        });
    });
  }

  putRename(projId, newPath) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/putRename/", { pid: projId, path: newPath })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              return resolve(response.data[0]);
            } else {
              return reject("put rename not found");
            }
          } else {
            return reject("put rename failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("put rename failed with error : " + err.message);
        });
    });
  }

  saveRepair(projectId, newPath) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectBrokenPath", {
        projectId,
        newPath,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project repair path failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project repair path failed with error : " + err.message);
        });
    });
  }

  updateProjectPathFolder(oldName, newName) {
    return new Promise((resolve, reject) => {
      db.put("/ProjectConnector/updateProjectPathFolder/", { oldName, newName })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update project path folder failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update project path folder failed with error : " + err.message);
        });
    });
  }
}
